import React, { useRef } from 'react'
import { components, useTranslation } from 'cng-web-lib'
import Namespace from '../../../../../constants/locale/Namespace'
import NbciUsInvoiceKeys from '../../../../../constants/locale/key/NbciUsInvoice'
import FormProperties from './TscaDetailsFormProperties'
import CngSection from '../../../../../components/cngcomponents/CngSection'
import TscaDetailsFieldsPlaceholder from './TscaDetailsFieldsPlaceholder'
import { FormProvider, useForm, useFormContext } from 'react-hook-form'
import _ from 'lodash'
import { Divider, Grid, Tooltip } from '@material-ui/core'
import makeValidationSchema from './TscaDetailsMakeValidationSchema'
import useCustomYupValidationResolver from '../../../../../components/aciacehighway/hooks/useCustomYupValidationResolver'

const {
  button: { CngButton, CngIconButton }
} = components

const { initialValues } = FormProperties.formikProps

function TscaDetailsSection() {
  const generatedIndex = useRef(0)
  const { getValues, setValue, watch } = useFormContext()

  const tscaDetails = watch('nbciusinvoiceTCSADetails')

  const { translate } = useTranslation(Namespace.NBCI_US_INVOICE)
  const translatedTextsObject = makeTranslatedTextsObject()

  function handleAddTscaDetails(data) {
    const tscaDetails = [...getValues('nbciusinvoiceTCSADetails'), data]

    setValue('nbciusinvoiceTCSADetails', tscaDetails, { shouldDirty: true })
  }

  function handleDeleteTscaDetails(index) {
    const tscaDetails = [...getValues('nbciusinvoiceTCSADetails')]

    tscaDetails.splice(index, 1)

    setValue('nbciusinvoiceTCSADetails', tscaDetails, { shouldDirty: true })
  }

  function handleEditTscaDetails(index, data) {
    const tscaDetails = [...getValues('nbciusinvoiceTCSADetails')]

    tscaDetails[index] = data

    setValue('nbciusinvoiceTCSADetails', tscaDetails , { shouldDirty: true })
  }

  function makeTranslatedTextsObject() {
    const nbciusinvoiceTCSADetails = translate(
      Namespace.NBCI_US_INVOICE,
      NbciUsInvoiceKeys.NBCIUSInvoiceTCSADetails.TITLE
    )

    return { nbciusinvoiceTCSADetails }
  }

  return (
    <CngSection title={translatedTextsObject.tscaDetails}>
      <Grid container spacing={2}>
        {_.isEmpty(tscaDetails) ? (
          <Grid item xs={12}>
            <TscaDetailsFieldsPlaceholder onAdd={handleAddTscaDetails} />
          </Grid>
        ) : (
          tscaDetails.map((item, index) => (
            <React.Fragment key={++generatedIndex.current}>
              <Grid item xs={12}>
                <TscaDetailsEntry
                  tscaDetails={item}
                  onAdd={handleAddTscaDetails}
                  onDelete={() => handleDeleteTscaDetails(index)}
                  onEdit={(data) => handleEditTscaDetails(index, data)}
                />
              </Grid>
              {index + 1 !== tscaDetails.length && (
                <Grid item xs={12}>
                  <Divider />
                </Grid>
              )}
            </React.Fragment>
          ))
        )}
      </Grid>
    </CngSection>
  )
}

function TscaDetailsEntry(props) {
  const { tscaDetails, onAdd, onDelete, onEdit } = props
  const { translate } = useTranslation(Namespace.NBCI_US_INVOICE)
  const methods = useForm({ defaultValues: tscaDetails,  resolver: useCustomYupValidationResolver(makeValidationSchema(translate)) })
  const {
    formState: { isDirty }
  } = methods

  function handleEditTscaDetails(data) {
    methods.trigger()
    methods.reset(data)
    onEdit(data)
  }

  return (
    <FormProvider {...methods}>
      <Grid alignItems='center' container spacing={1}>
        <Grid item xs={12}>
          <FormProperties.Fields />
        </Grid>
        <Grid item xs={12}>
          <Grid justify='flex-end' container spacing={1}>
            {isDirty ? (
              <>
                <Grid item xs='auto'>
                  <CngButton
                    color='secondary'
                    onClick={() => methods.reset()}
                    size='medium'
                  >
                    Reset
                  </CngButton>
                </Grid>
                <Grid item xs='auto'>
                  <CngButton
                    color='primary'
                    onClick={methods.handleSubmit(handleEditTscaDetails)}
                    size='medium'
                  >
                    Save changes
                  </CngButton>
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs='auto'>
                  <Tooltip placement='bottom' title='Add'>
                    <span>
                      <CngIconButton
                        icon={['fal', 'plus']}
                        onClick={() => onAdd(initialValues)}
                        size='small'
                        type='outlined'
                      />
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs='auto'>
                  <Tooltip placement='bottom' title='Clone'>
                    <span>
                      <CngIconButton
                        icon={['fal', 'copy']}
                        onClick={() => onAdd({ ...tscaDetails, id: undefined })}
                        size='small'
                        type='outlined'
                      />
                    </span>
                  </Tooltip>
                </Grid>
                <Grid item xs='auto'>
                  <Tooltip placement='bottom' title='Delete'>
                    <span>
                      <CngIconButton
                        icon={['fal', 'trash']}
                        onClick={() => onDelete(tscaDetails)}
                        size='small'
                        type='outlined'
                      />
                    </span>
                  </Tooltip>
                </Grid>
              </>
            )}
          </Grid>
        </Grid>
      </Grid>
    </FormProvider>
  )
}

export default TscaDetailsSection
